import { Dispatch } from "@reduxjs/toolkit";
import { setBMSR, toggleRider } from "../../features/gms-proposal-forms/attachable-rider/attachable-riders.slice";
import { addRiderLevelRankingInput } from "../../features/gms-proposal-forms/coverage/level-ranking/coverage-type-level-ranking.slice";
import {  PROPOSAL_RIDERS } from "../../constant/gms-constant";
import { Riders } from "../../api/gms/proposal/proposal-api-state";
import { pa_addRiderLevelRankingInput, pa_setBMSR } from "../../features/propose-data/propose-data-slice";

export const populateRidersLevelRanking = (
    dispatch: Dispatch,
    riders: Riders[],
    type: 'current' | 'proposed',
    optionForGroupDengueRider?: { id: number; fAmount: number; label: string }[],
) => {

    // Toggle all riders in the global state
    riders.forEach(rider => {
        dispatch(toggleRider({ id: rider.rider_id, label: rider.rider_name }));
    });

    // Handle coverage-type riders
    riders.forEach((rider) => {
        const dynamicInputs = (rider.values ?? []).map(value => ({
            label: value.designation,
            fAmount: value.amount ?? 0,
        }));
        const riderData = {
            id: rider.rider_id,
            label: rider.rider_name,
            inputs: dynamicInputs,
            values: rider.values,
        };

        if (type === 'current') {
            dispatch(addRiderLevelRankingInput(riderData));
        }

        if (type === 'proposed') {
            dispatch(pa_addRiderLevelRankingInput(riderData));
        }
    });

    // Specific riders
    const riderMap: Record<string, number[]> = {
        BMSR: [
            PROPOSAL_RIDERS.BMSR.productFor.GYRT,
            PROPOSAL_RIDERS.BMSR.productFor.GCI,
        ],
    };

    const riderBMSR = riders.find((r) => riderMap.BMSR.includes(r.rider_id));

    const bmsrData = {
        id: riderBMSR?.rider_id ?? 0,
        label: riderBMSR?.rider_name ?? "",
        inputs: [
            {
                fAmount: riderBMSR?.values?.[0]?.amount ?? 0,
            },
        ],
    };
    if (type === 'current') {
        dispatch(setBMSR(bmsrData));
    }
    if (type === 'proposed') {
        dispatch(pa_setBMSR(bmsrData));
    }
};